module.exports = __webpack_public_path__ + "static/media/40x40-9.645fe4d2.png";